import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import ProductCard from '../components/product/ProductCard'
import styles from './Search.module.css'

export default function Search() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [keyword, setKeyword] = useState(searchParams.get('q') || '')

  // TODO: APIから取得
  const products = [
    { id: '1', title: 'アクリルスタンド', price: 1500, images: [], status: 'available' as const },
    { id: '2', title: 'ペンライト', price: 3000, images: [], status: 'sold' as const },
  ]

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    setSearchParams({ q: keyword })
  }

  return (
    <div className={styles.container}>
      <form onSubmit={handleSearch} className={styles.searchBar}>
        <input
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="商品名、アーティスト名で検索"
        />
        <button type="submit">検索</button>
      </form>

      <div className={styles.filters}>
        <select>
          <option value="">カテゴリ</option>
          <option value="acrylic">アクリルスタンド</option>
          <option value="penlight">ペンライト</option>
          <option value="photo">写真・ブロマイド</option>
          <option value="other">その他</option>
        </select>
        <select>
          <option value="">価格</option>
          <option value="0-1000">〜1,000円</option>
          <option value="1000-3000">1,000〜3,000円</option>
          <option value="3000-5000">3,000〜5,000円</option>
          <option value="5000-">5,000円〜</option>
        </select>
        <select>
          <option value="">状態</option>
          <option value="new">新品・未使用</option>
          <option value="like_new">未使用に近い</option>
          <option value="good">目立った傷や汚れなし</option>
        </select>
        <select>
          <option value="new">新着順</option>
          <option value="price_asc">価格が安い順</option>
          <option value="price_desc">価格が高い順</option>
        </select>
      </div>

      <p className={styles.resultCount}>{products.length}件の商品</p>

      <div className={styles.productGrid}>
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  )
}
